import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import averagePriceChart from '../Assets/the-new-way.png'
import oldNewImage1 from '../Assets/new-landing-page-images/old_new.png'
import oldNewImage2 from '../Assets/new-landing-page-images/old_new1.png'
import oldNewImage3 from '../Assets/new-landing-page-images/old_new_2.png'
import oldWayImage from  '../Assets/new-landing-page-images/old_way.png'
import newWayImage from '../Assets/new-landing-page-images/new_way.png'
import CrossUlIcon from '../Icons/CrossUlIcon'
import CheckULIcon from '../Icons/CheckULIcon'
import { Link } from 'react-router-dom'
import { Parallax } from 'react-scroll-parallax';
const OldAndNew = () => {
  return (
    <div className='oldAndNew'>
        <Container fluid className='px-3 px-lg-4 px-xl-5'>
            <Row className='g-0'>
                <Col lg="4">
                    <div className="oldAndNewChild oanLeft py-5 pe-lg-5 pe-4 ps-4 ps-lg-0">
                        <div className="py-lg-5">
                            <img src={oldWayImage} alt="" className="img-fluid smallImage" />
                            <h2>The old way</h2>
                            <span className='pdsbadge my-2'>Aimlessly Scour Products</span>
                            <ul>
                                <li> <span><CrossUlIcon/></span> Manual research</li>
                                <li> <span><CrossUlIcon/></span> Hours spent gathering data</li>
                                <li><span><CrossUlIcon/></span> Incomplete competitor insights</li>
                                <li><span><CrossUlIcon/></span> Missed opportunities due to outdated information</li>
                                <li><span><CrossUlIcon/></span> Fragmented tools for research and tracking</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                <Col lg="8">
                    <div className="oldAndNewChild oanRight py-5 p-4 p-lg-5">
                        <div className="py-lg-5">
                            <Row className='align-items-center'>
                                <Col lg="6" xl="6" xxl="5">
                                    <img src={newWayImage} alt="" className="img-fluid smallImage" />
                                    <h2>
                                        The new way  <span className='versus'>VS</span>
                                    </h2>
                                    <span className='pdsbadge bg-white my-2'>Leverage Nformed</span>
                                    <ul>
                                        <li><span><CheckULIcon/></span>AI-powered research</li>
                                        <li><span><CheckULIcon/></span>Centralized data for quick research</li>
                                        <li><span><CheckULIcon/></span>Comprehensive competitor analysis</li>
                                        <li><span><CheckULIcon/></span>Real-time updates on market trends</li>
                                        <li><span><CheckULIcon/></span>All-in-one tool for efficiency</li>
                                    </ul>
                                    <div className="mt-4 mt-lg-5 oanRightFooter">
                                        {/* <button className='btn nformed-btn'>Try Nformed Today</button> */}
                                        <Link to="/sign-up" className='btn nformed-btn' >Try Nformed Today</Link>
                                        <p> Start your free trial. Cancel anytime.</p>
                                    </div>
                                </Col>
                                <Col lg="6" xl="6" xxl="7">
                                    <Parallax speed={30} scale={[1, 0.7, 'easeInQuad']}>
                                        <div className="old_new_images">
                                            {/* <Parallax  translateX={[0, 15]}>
                                                <img src={averagePriceChart} alt="" className="img-fluid" />
                                            </Parallax> */}
                                            <Parallax  translateY={[25, 0]}>
                                                <img src={oldNewImage1} alt="" className="img-fluid" style={{maxWidth: '350px', display: 'block', marginLeft: 'auto'}} />
                                            </Parallax>
                                            <div className="d-flex justify-content-end">
                                                <Parallax  translateX={[-15, 15]}>
                                                    <img src={oldNewImage3} alt="" className="img-fluid" style={{marginTop: '10px', maxWidth: '230px'}}  />
                                                </Parallax>
                                                <Parallax  translateX={[25, 10]}>
                                                    <img src={oldNewImage2} alt="" className="img-fluid" style={{marginTop: '-10px',  maxWidth: '170px'}} />
                                                </Parallax>
                                            </div>
                                        </div>
                                    </Parallax>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
  )
}

export default OldAndNew